/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let ProductOverviewImport;
let KeyFeaturesImport;
let ItemRelatedGroupsImport;
let RatingsAndReviewsImport;
let FeatureBasedRecommendationsImport;

/** *********************
 * Product Overview
 ********************** */
export const ProductOverviewLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview')
  .then((module) => {
    const { ProductOverview } = module;

    ProductOverviewImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ProductOverview {...props} />
        </QueryProvider>
      );
    };
  });

export const ProductOverview = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverview
  : (props) => <ProductOverviewImport {...props} />;

export const ProductOverviewModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverview.dataModel
  : {};

/** *********************
 * Key Features (part of Product Overview)
 ********************** */
export const KeyFeaturesLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview')
  .then((module) => {
    const { KeyFeatures } = module;

    KeyFeaturesImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <KeyFeatures {...props} />
        </QueryProvider>
      );
    };
  });

export const KeyFeatures = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).KeyFeatures
  : (props) => <KeyFeaturesImport {...props} />;

export const KeyFeaturesModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).KeyFeatures.dataModel
  : {};

/** *********************
 * IRG
 ********************** */
export const ItemRelatedGroupsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "item-related-groups" */
  '@thd-olt-component-react/item-related-groups')
  .then((module) => {
    const { ItemRelatedGroups } = module;

    ItemRelatedGroupsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ItemRelatedGroups {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroups = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups')).ItemRelatedGroups
  : (props) => <ItemRelatedGroupsImport {...props} />;

export const ItemRelatedGroupsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups')).ItemRelatedGroups.dataModel
  : {};

/** *********************
 * FBR
 ********************** */
export const FeatureBasedRecommendationsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "feature-based-recommendations" */
  '@thd-olt-component-react/feature-based-recommendations')
  .then((module) => {
    const { FeatureBasedRecommendations } = module;

    FeatureBasedRecommendationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <FeatureBasedRecommendations {...props} />
        </QueryProvider>
      );
    };
  });

export const FeatureBasedRecommendations = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations
  : (props) => <FeatureBasedRecommendationsImport {...props} />;

export const FeatureBasedRecommendationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews')
  .then((module) => {
    const { RatingsAndReviews } = module;

    RatingsAndReviewsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <RatingsAndReviews {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviews = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviews
  : (props) => <RatingsAndReviewsImport {...props} />;

export const RatingsAndReviewsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviews.dataModel
  : {}
